var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgWelcomeBanner = function SvgWelcomeBanner(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 113,
    viewBox: "0 0 210 113",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "prefix__a",
    width: "129.7%",
    height: "176.5%",
    x: "-14.8%",
    y: "-33.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    radius: 1,
    result: "shadowSpreadOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    in: "shadowSpreadOuter2",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter3",
    result: "shadowBlurOuter3",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter3",
    result: "shadowMatrixOuter3",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "prefix__c",
    width: "129.7%",
    height: "176.5%",
    x: "-14.8%",
    y: "-33.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    radius: 1,
    result: "shadowSpreadOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    in: "shadowSpreadOuter2",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter3",
    result: "shadowBlurOuter3",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter3",
    result: "shadowMatrixOuter3",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "prefix__b",
    d: "M50.908 0c1.657 0 3 1.343 3 3v7.942c0 1.657-1.343 3-3 3L7.19 13.94l-1.845 6.972L3.09 13.94H3c-1.657 0-3-1.342-3-3V3c0-1.657 1.343-3 3-3h47.908z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__d",
    d: "M50.908 0c1.657 0 3 1.343 3 3v7.942c0 1.657-1.343 3-3 3L7.19 13.94l-1.845 6.972L3.09 13.94H3c-1.657 0-3-1.342-3-3V3c0-1.657 1.343-3 3-3h47.908z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00C48C",
    d: "M80.177 41.865c-6.052-5.15-8.096-6.392-13.401-4.639-5.306 1.753-7.9 3.36-15.13 4.456-4.441.73-9.04.183-13.166-1.497l-14.894 1.388C21.7 41.353.517 78.316.006 85.986c-.314 4.711 11.2 11.98 14.423 12.71 1.297.292 3.616-11.322 4.362-12.382l-4.833-1.388c.864-2.008 3.772-6.976 5.698-9.642.59-.84 5.187-7.89 5.816-10.592.118.256.786 5.37 1.415 7.013 1.179 3.031 2.79 4.748 2.79 7.158 0 2.411-.314 11.98-2.2 16.29-1.887 4.31-4.638 14.281-4.638 14.281l47.63-.256s-1.728-19.029-1.02-25.566c0 0-.748-2.63.667-6.429 2.319-6.282 2.987-15.632 2.594-17.093-.59-2.3 13.99 17.166 17.174 22.097 1.336 2.045-16.781 5.661-18.274 7.232-1.572 1.643 1.532 6.1 1.532 6.1s31.597-3.58 31.44-8.072c-.158-4.493-17.37-39.629-24.405-45.582z",
    transform: "translate(5) translate(36.119) translate(11.86)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDC2CC",
    d: "M43.396 35.04c-3.063 4.887-8.895 6.029-8.895 6.029l2.114 3.8c6.54 6.42 16.984 6.775 23.956.815l2.317-4.6s-6.895-1.998-8.98-6.044c-2.085-4.045-10.512 0-10.512 0z",
    transform: "translate(5) translate(36.119) translate(11.86)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E254C",
    d: "M54.532 26.056c7.067 3.245 14.036 8.82 10.033 15.178-4.003 6.358-6.186 7.162-.035 17.577 0 0-5.724-.661-8.343-6.098-3.688-7.655.65-16.007 1.698-18.762 1.048-2.754-3.353-7.895-3.353-7.895z",
    transform: "translate(5) translate(36.119) translate(11.86)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59BBF7",
    d: "M60.142 21.676c1.727-2.842 3.74-1.088 4.028-.503.288.585-.288 3.51-1.438 5.264-1.151 1.755-3.688 3.088-3.717 2.422-.029-.667 1.127-7.183 1.127-7.183z",
    transform: "translate(5) translate(36.119) translate(11.86)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDC2CC",
    d: "M38.461 21.676c-1.725-2.842-3.737-1.088-4.025-.503-.288.585.288 3.51 1.438 5.264 1.15 1.755 3.686 3.088 3.717 2.422.032-.667-1.13-7.183-1.13-7.183z",
    transform: "translate(5) translate(36.119) translate(11.86)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDC2CC",
    d: "M38.798 7.732c-3.477 8.827-2.318 14.444 0 20.328 1.903 4.836 6.663 11.501 11.008 11.234 4.346-.268 12.747-9.896 12.168-20.863-.58-10.966-13.906-20.327-23.176-10.699z",
    transform: "translate(5) translate(36.119) translate(11.86)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E254C",
    d: "M44.82 3.249c.57 9.091 3.004 12.523 13.65 15.625 6.825 1.989 0 11.648 0 11.648s9.384-4.83 6.825-13.636c0 0-.284-21.592-20.474-13.637z",
    transform: "translate(5) translate(36.119) translate(11.86)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E254C",
    d: "M45.833 6.734c1.962 5.647-2.47 10.292-6.014 12.614-3.545 2.323 5.137 10.63 0 15.678-2.363 2.323-6.203 1.162-6.203 1.162s7.68 2.032 2.658-11.904C31.253 10.348 38.933-.394 45.431 2.8l.402 3.934z",
    transform: "translate(5) translate(36.119) translate(11.86)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E254C",
    d: "M44.074 4.43C45.605-.346 54.647-1.298 57.52 1.76l-4.35 3.451-9.096-.78z",
    transform: "translate(5) translate(36.119) translate(11.86)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7B8E",
    d: "M0 106.739H116.442V112.66900000000001H0z",
    transform: "translate(5) translate(36.119)"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(5) translate(36.119) translate(25.337 68.464)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M.15 3.002S.114.178 2.853.063C5.592-.05 63.605.025 63.605.025s2.552.305 2.627 2.405c.075 2.1.075 33.287.075 33.287s.038 2.405-2.476 2.482c-2.515.076-61.654.076-61.654.076S-.037 37.702 0 35.45C.038 33.198.15 3.002.15 3.002z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.526,
    cy: 19.513,
    fill: "#CCD0D8",
    rx: 4.47,
    ry: 4.503
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5) translate(146.092 42.588)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#prefix__a)",
    xlinkHref: "#prefix__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#A186FF",
    xlinkHref: "#prefix__b"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.086,
    height: 8.625,
    x: 4.313,
    y: 2.695,
    fill: "#FFF",
    opacity: 0.86,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.267,
    height: 1.617,
    x: 15.633,
    y: 3.235,
    fill: "#FFF",
    opacity: 0.86,
    rx: 0.809
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.946,
    height: 1.617,
    x: 15.633,
    y: 7.008,
    fill: "#FFF",
    opacity: 0.86,
    rx: 0.809
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5) matrix(-1 0 0 1 53.908 45.822)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#prefix__c)",
    xlinkHref: "#prefix__d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FF647C",
    xlinkHref: "#prefix__d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.086,
    height: 8.625,
    x: 40.431,
    y: 2.695,
    fill: "#FFF",
    opacity: 0.86,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31.267,
    height: 1.617,
    x: 4.313,
    y: 3.235,
    fill: "#FFF",
    opacity: 0.86,
    rx: 0.809
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.946,
    height: 1.617,
    x: 15.633,
    y: 7.008,
    fill: "#FFF",
    opacity: 0.86,
    rx: 0.809
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWelcomeBanner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/welcomeBanner.9318f5ea.svg";
export { ForwardRef as ReactComponent };